module.exports = __webpack_public_path__ + "img/P32-zh.a99d1b3c.png";